import { Form } from 'factorial-form'

class SubcriptionForm extends Form {
  constructor(values: {}) {
    super(values, {
      plan: 'string',
      token: 'string',
      name: 'string',
      coupon: 'string',
    })
  }
}

export default SubcriptionForm
